import { OPEN_THIRD_PARTY_WIDGET } from 'calling-global-api/constants/EventListeners';
export function triggerHostMessageOpenThirdPartyWidget(data) {
  if (window.hsCalling.triggerEvent) {
    window.hsCalling.triggerEvent({
      event: OPEN_THIRD_PARTY_WIDGET,
      data
    });
  }
}